import { SemanticColorKey } from '@notino/react-styleguide-v20';

/* GRID DIVIDER SETTING */
export const DIVIDER_COLOR: SemanticColorKey = 'border.divider';
export const DIVIDER_HEIGHT = '0.0625rem';
